import { permanentRedirect, redirect } from "next/navigation";
import { useLocale } from "../client";
import { replaceLocale, safeLocale, type Routing } from "../shared";

type RedirectArgs = Parameters<typeof redirect>;

export const createNavigationFunctions = (routing: Routing) => {
  const localizedRedirect = (
    url: RedirectArgs[0],
    options?: {
      type: RedirectArgs[1];
      locale: string;
    }
  ) => {
    const locale = useLocale();

    if (!locale) {
      throw new Error(
        "No locale detected on the client. Page is likely missing a wrapper IntlProvider"
      );
    }

    const localeToUse = safeLocale(routing, options?.locale || locale);

    return redirect(
      replaceLocale(url, localeToUse, routing, options?.locale),
      options?.type
    );
  };

  const localizedPermanentRedirect = (
    url: RedirectArgs[0],
    options?: {
      locale?: string;
    }
  ) => {
    const locale = useLocale();

    if (!locale) {
      throw new Error(
        "No locale detected on the client. Page is likely missing a wrapper IntlProvider"
      );
    }

    const localeToUse = safeLocale(routing, options?.locale || locale);

    return permanentRedirect(
      replaceLocale(url, localeToUse, routing, options?.locale)
    );
  };

  return {
    redirect: localizedRedirect,
    permanentRedirect: localizedPermanentRedirect,
  };
};
